import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import Titlebar from '../../TitleBar';
import { TableBody } from '.';
import { Pagination, SearchTable, TableHeader } from '../../TableTemplate/index';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { applyFilter, emptyRows, getComparator, extractDate } from '../../../Utils/table';
import { StitchEntrylist } from '../../TitleList';
import { fetchStitchContraRegister, fetchStitchingReg } from '../../../Store/PHPSlice/Stitching/StitchApi';
import { selectStitchContraRegister, selectStitchReg } from '../../Selectors/StitchSelector/StitchingSelectors';


const StitchContractorReg = () => {
    const dispatch = useDispatch();
    const stitchlist = useSelector(selectStitchContraRegister);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('empId');
    const [selected, setSelected] = useState([]);
    const [filterName, setFilterName] = useState('null');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [firstIndex, setFirstIndex] = useState(0);
    const [lastIndex, setLastIndex] = useState(0);

    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        dispatch(fetchStitchContraRegister());
    }, [dispatch]);


    const compData = Array.isArray(stitchlist.data) ? stitchlist?.data?.map((item, index) => (
        {
            serialNumber: index + 1,
            srno: item.ID,
            dt: item.dt,
            stMemo: item.stMemo,
            ctMemo: item.ctMemo,
            fmemo: item.fmemo,
            fuId: item.fuId,
            sono: item.sono,
            empNm: item.empNm,
            itemNm: item.itemNm,
            totQty: item.totQty,
            totmat: item.totmat,
            sts: item.sts,
            rests: item.rests,
            firmNm: item.firmNm,
            firmId: item.firmId
        }
    )) : [];



    const handleSort = (event, id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = compData.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };


    const totalCount = compData ? compData.length : 0;
    const npages = Math.ceil(totalCount / recordsPerPage);
    const numbers = Array.from({ length: npages }, (_, i) => i + 1);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset to first page on search
    };

    const filteredData = (Array.isArray(compData) ? compData : []).filter(item =>
        item.stMemo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.ctMemo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.empNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.itemNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.dt?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.firmNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.fmemo?.toLowerCase().includes(searchTerm.toLowerCase())
    );


    const dataFiltered = applyFilter({
        inputData: filteredData,
        comparator: getComparator(order, orderBy),
    });
    const totalPages = Math.ceil(dataFiltered.length / itemsPerPage);
    const displayedData = dataFiltered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);


    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

    const handleNextPageRange = () => {
        setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
    };

    const handlePreviousPageRange = () => {
        setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page on change
    };

    return (
        <>
            <Titlebar data={StitchEntrylist} />

            <div style={{ margin: '1% 0.5%' }}>
                <h2>Contractor Register</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>


                            <SearchTable
                                handleItemsPerPageChange={handleItemsPerPageChange}
                                searchTerm={searchTerm}
                                handleSearchChange={handleSearchChange}
                                totalItems={filteredData?.length}
                            />


                            <TableContainer style={{ marginTop: '2%' }}>
                                <Table>
                                    <TableHeader
                                        headCells={
                                            [
                                                { id: 'srno', label: 'SrNo' },
                                                { id: 'dt', label: 'Date' },
                                                { id: 'firmNm', label: 'Firm' },
                                                { id: 'stMemo', label: 'Stitch Memo No.' },
                                                { id: 'ctMemo', label: 'Cutting Memo No.' },
                                                { id: 'fmemo', label: 'Fusion Memo No.' },
                                                { id: 'sono', label: 'SO No.' },
                                                { id: 'empNm', label: 'Master' },
                                                { id: 'itemNm', label: 'Item' },
                                                { id: 'totQty', label: 'Total Qty.' },
                                                { id: 'totmat', label: 'Total Mateiral' },
                                                { id: '', label: 'View' },
                                                { id: '', label: 'Inward' },
                                                { id: '', label: 'Edit' },
                                                { id: '', label: 'Delete' }

                                            ]
                                        }
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleSort}
                                        numSelected={selected.length}
                                        rowCount={compData.length}
                                        onSelectAllClick={handleSelectAllClick}
                                    />
                                    <tbody>
                                        {displayedData?.map((row) => (
                                            <TableBody
                                                key={row.srno}
                                                id={row.srno}
                                                dt={row.dt}
                                                stMemo={row.stMemo}
                                                ctMemo={row.ctMemo}
                                                sono={row.sono}
                                                empNm={row.empNm}
                                                itemNm={row.itemNm}
                                                totQty={row.totQty}
                                                totmat={row.totmat}
                                                sts={row.sts}
                                                rests={row.rests}
                                                fuId={row.fuId}
                                                fmemo={row.fmemo}
                                                firmNm={row.firmNm}
                                                firmId={row.firmId}
                                                serialNumber={row.serialNumber}
                                                selected={selected.indexOf(row.name) !== -1}
                                                handleClick={(event) => handleClick(event, row.name)}
                                            />
                                        ))}
                                    </tbody>
                                </Table>
                            </TableContainer>


                            <Pagination
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                                handlePreviousPageRange={handlePreviousPageRange}
                                visiblePageNumbers={visiblePageNumbers}
                                pageNumber={pageNumbers}
                                pageRange={pageRange}
                                totalPages={totalPages}
                                handleNextPageRange={handleNextPageRange}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default StitchContractorReg;
